export default __webpack_public_path__ + "static/viners-logo.754a4139.svg";